import React from "react";
import styled from "styled-components";
const CircleImageFigure = styled.figure`
  display: inline-flex;
  align-items: center;
  align-self: center;
  overflow: hidden;
  width: ${({ sizePx }) => sizePx};
  height: ${({ sizePx }) => sizePx};
  border-radius: 100%;
  margin: 0;
  background-image: ${({ url }) => `url(${url})`};
  background-size: cover;
  background-position: center;
  img {
    min-width: ${({ sizePx }) => sizePx};
    min-height: ${({ sizePx }) => sizePx};
  }
`;
const FigCaption = styled.figcaption`
z-index: -1;
`
export default function CircleImage({ url, sizePx = "40px", className = "", alt = "" }) {
  return (
    <CircleImageFigure sizePx={sizePx} url={url} className={`me-2 ${className}`}>
      <FigCaption >{alt}</FigCaption>
    </CircleImageFigure>
  );
}
